module.exports = __webpack_public_path__ + "88eba24ec32b062b15306db80289f2b7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/screenprint-tshirt-black-design.png
// module id = 808
// module chunks = 0